/** Extraits originaux. Rien n’est réécrit. Le fil « trois femmes » n’est pas publié. */

export const HUMOUR_JOKES = [
  {
    id: "towing",
    when: "30 août 2026",
    status: "",
    lines: [
      { who: "Pierre", text: "La belt de quelle  véhicule" },
      { who: "Éric", text: "Steve j’ai fait du towing Toute ma vie et maintenant à ma retraite j’en fait encore" },
      { who: "Chantal / Luc", text: "Le 6 roues à Steve" },
      { who: "Pierre", text: "Ha le dévouement sais dans toi" },
      { who: "Steve", text: "Au moin c etais pas loing" },
      { who: "Éric", text: "Ta oublier de me donner ta carte de caa lol" },
      { who: "Steve", text: "Je  suis un bon gars je te trouve des chose a faire a ta retraite" },
    ],
  },
  {
    id: "cafe",
    when: "16 août 2026",
    status: "",
    lines: [
      { who: "Natalie", text: "Mais je m’occupe pas du café" },
      { who: "Steve", text: "Jus d orange pour luc lol" },
      { who: "Natalie", text: "Juste du vin du jus de mangue" },
    ],
  },
  {
    id: "souper",
    when: "19 mars 2026",
    status: "À confirmer",
    lines: [
      { who: "Chantal / Luc", text: "je connais quelqu'un qui peux nous planifier nos souper" },
    ],
  },
];

export const HUMOUR_ANECDOTE = {
  who: "Marcel",
  when: "30 août 2026",
  text: `Bon… dimanche soir, retour de notre fin de semaine de prospection, et je vais sortir un peu ma plume.

Sérieusement, quelle belle gang. On a eu du fun, on a ri, on a jasé, on a rencontré du monde vraiment spécial, et ça m’a juste confirmé une chose : la chasse va être mémorable avec vous autres.

Je veux surtout lever mon chapeau aux femmes. Vous avez été exceptionnelles toute la fin de semaine. Vous avez embarqué dans notre passion, dans nos histoires, nos folies, nos plans et nos petites niaiseries, avec une énergie incroyable. Ça a rendu la fin de semaine encore plus spéciale, et ça mérite vraiment d’être souligné.

Et une mention toute spéciale à Éric, notre chauffeur, qui a été un vrai bonheur à avoir avec nous. Entre sa bonne humeur, son expérience de vie et toutes ses histoires, on aurait presque pu passer la fin de semaine juste à l’écouter parler. Même Natalie n’en revenait pas de certaines histoires!

Bref, je reviens de là avec le sourire, de beaux souvenirs, et encore plus hâte à la chasse. Si la prospection était un avant-goût de ce qui s’en vient, on est en voiture pour quelque chose de vraiment spécial.

Merci à toute la gang`,
};

export const KETCHUP_IMAGE = {
  status: "À valider par Marcel",
  caption: "Ketchup pour notre fan de ketchup",
  note: "La fausse bouteille n’est pas dans l’export du 31 août. Elle n’est pas affichée.",
};
